// extracted by mini-css-extract-plugin
export default {"bannerImage":"index_bannerImage_vG-U7","bannerPic":"index_bannerPic_QKkEJ"};